import { render } from "./errors.vue?vue&type=template&id=956e57b6"
import script from "./errors.vue?vue&type=script&lang=ts&setup=true"
export * from "./errors.vue?vue&type=script&lang=ts&setup=true"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "956e57b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('956e57b6', script)) {
    api.reload('956e57b6', script)
  }
  
  module.hot.accept("./errors.vue?vue&type=template&id=956e57b6", () => {
    api.rerender('956e57b6', render)
  })

}

script.__file = "resources/ts/components/form/errors.vue"

export default script